<template>

    <vx-expandable-card class="mt-4 relative">
        <template v-slot:header>
            <div class="flex items-center gap-2">
                <font-awesome-icon widthAuto :icon="props.icon" class="text-base"></font-awesome-icon>
                <div class="text-lg">
                    <slot name="header"></slot>
                </div>
            </div>
            <div v-if="$slots.description" class="text-slate-500 text-sm font-normal">
                <slot name="description"></slot>
            </div>
        </template>

        <template v-slot:content>
            <div class="flex flex-col gap-6 mt-3 lg:gap-8 lg:mt-5">
                <slot></slot>
            </div>
        </template>
    </vx-expandable-card>
</template>

<script setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxExpandableCard } from '@voxie/frontend-components';

const props = defineProps({
    icon: {
        required: true,
    }
})
</script>
